// Production and development browser requests are same-origin. In development
// CRA's optional proxy forwards /api to the API target configured in .env.
export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return normalizedPath;
}

export function apiFetch(path, options = {}) {
  return fetch(apiUrl(path), { credentials: 'same-origin', ...options });
}
